// extracted by mini-css-extract-plugin
module.exports = {"buttonHolder":"styles__buttonHolder___1jxOV"};